import { ReactNode } from "react";

import { Content } from "./styles";

interface ModalIconProps {
  children: ReactNode | string;
}

export const ModalHeading = ({ children }: ModalIconProps) => {
  return (
    <Content display="flex" direction="column" justify="center" mb="32">
      {children}
    </Content>
  );
};
